import {
  Component,
  ComponentRef,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GetterService } from '../app/service/getter-service.service';
import { PosthogService } from './analytics/services/posthog.service';
import { AttributionService } from './analytics/services/attribution.service';
import { Subscription } from 'rxjs';
import { ApiService } from './service/api.service';
import { WebCustomer } from 'src/Model/WebCustomer';
import { environment } from 'src/environments/environment';
import { UserService } from './service/user.service';
import { Meta, Title } from '@angular/platform-browser';
// type-only: the component itself is loaded lazily (lazy-components.ts)
import type {
  RecipeOptionModalComponent,
  RecipeOptionModalState,
} from './recipe-option-modal/recipe-option-modal.component';
import { RecipeOptionModalService } from './recipe-option-modal/recipe-option-modal.service';
import { ThemeService } from './service/theme.service';
import { NewRecomendationsService } from './new-recomendations/new-recomendations.service';
import {
  loadNewRecomendations,
  loadNewSideCart,
  loadRecipeOptionModal,
  loadRetailAiWidget,
} from './lazy-components';
import { prefetchLazyComponent, whenIdle } from './shared/lazy-component';
import { isNewDesign } from './design/design.service';
import { scrollPageTo } from './shared/page-scroll';
import { pageSegment } from 'src/app/brand/brand-context';
declare let fbq: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // see `booting`
  host: { '[class.app-booting]': 'booting' },
})
export class AppComponent implements OnInit, OnDestroy {
  isHeaderVisible: boolean = true;
  isFooterVisible: boolean = true;
  isWhatsAppVisible = true;
  isAllergenseFooterVisible: boolean = false;
  isBottomMenuVisible: boolean = true;
  whatsappno: number;
  brand_Name: string;
  /*cart id*/
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  fbVerification: HTMLMetaElement = document.querySelector('#fbVerification');
  fbPixelScript: HTMLScriptElement;
  /* Bottom Menu */
  bottomMenu: boolean = false;
  showRetailAIWidget: boolean = false;
  assistantName: string;

  /**
   * TemplateData.NewDesign (DesignService): picks the header and the
   * recommendations popup. null until the brand config arrives, so neither
   * header mounts (and fetches) before the brand is known.
   */
  newDesign: boolean | null = null;

  /**
   * True until the splash starts to fade. The page lays out under the splash
   * before the brand config arrives (the route's skeleton, the footer), and
   * the header only mounts once it does, pushing everything down by its
   * height. Nobody sees that move — the splash is on top — but Chrome still
   * scores it as a layout shift (~0.2 CLS on the menu). Kept
   * visibility: hidden meanwhile (app.component.scss), the content is not
   * painted, so it can't shift; layout and data loading go on as before.
   */
  booting = true;

  webCusSub: Subscription;
  recipeOptionModalState: RecipeOptionModalState | null = null;

  /* lazily loaded components, rendered with appLazyComponent */
  readonly loadRetailAiWidget = loadRetailAiWidget;
  readonly loadRecipeOptionModal = loadRecipeOptionModal;
  readonly loadNewRecomendations = loadNewRecomendations;
  /** set once, by NewRecomendationsService.mount$ (idle after boot, or the first open) */
  mountRecomendations = false;
  private recomendationsMountSub: Subscription;
  private idleWorkScheduled = false;

  constructor(
    private _router: Router,
    private _local: GetterService,
    private apiService: ApiService,
    private userService: UserService,
    private meta: Meta,
    private title: Title,
    private posthog: PosthogService,
    private attribution: AttributionService,
    private recipeOptionModalService: RecipeOptionModalService,
    /* injected for its side effect: applies TemplateData.Theme to <html> */
    private theme: ThemeService,
    private zone: NgZone,
    private newRecomendations: NewRecomendationsService
  ) {
    // Campaign attribution: read utm_* off the landing URL before any
    // redirect / router navigation strips the query string.
    this.attribution.captureFromUrl();

    this.userService.refreshCustomerProfile();

    const page = pageSegment();
    // Inside the native app webview the portal is opened on an `app-*` page (app-menu, app-new-menu, …).
    const app = typeof page === 'string' && page.startsWith('app-');

    if (!JSON.parse(this._local.getSessionItem('app'))) {
      this._local.setSessionItem('app', app);
    }
    environment.production;
    console.log(
      '%c' + 'APP VERSION : ' + environment.appVersion,
      'background: red; color: #fff;padding:10px'
    );

    if (this._local.get('access_token') == 'guest') {
      this._local.remove('guestEmail');
      this._local.remove('guestLastName');
      this._local.remove('guestFirstName');
      this._local.remove('guestContact');
      this._local.remove('access_token');
    }
  }

  ngOnInit() {
    this._local.remove('deliveryType'); //for RecipeListView postcode validation

    /** 
    For stripe parallel Order Protection in case it is not removed during request cycle then refereh page will
    Remove the flag to allow future submissions
    */
    this._local.remove('isSubmitting');

    this.isHeaderVisible = true;

    this._router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) scrollPageTo(0, 'auto');
    });

    this.recipeOptionModalService.modalState$.subscribe((state) => {
      console.log('AppComponent received modal state:', state);
      this.recipeOptionModalState = state;
    });

    this.recomendationsMountSub = this.newRecomendations.mount$.subscribe(
      (mount) => {
        if (mount) this.mountRecomendations = true;
      }
    );

    this.getwebCustomer();
    this.watchScrollForFloatingButtons();
    // never let the splash outstay a failed or very slow config call
    this.splashTimer = setTimeout(() => this.hideSplash(), AppComponent.SPLASH_MAX_MS);
  }

  ngOnDestroy(): void {
    this.webCusSub.unsubscribe();
    this.recomendationsMountSub?.unsubscribe();
    document.removeEventListener('scroll', this.onPageScroll, true);
    clearTimeout(this.fabIdleTimer);
    clearTimeout(this.splashTimer);
  }

  /* ---- boot splash ------------------------------------------------------
     #splash-screen lives outside <app-root> (index.html), so bootstrapping
     leaves it up. It comes down once the WebCustomer payload has landed —
     ThemeService subscribes first, so the --ui-* tokens are already on
     <html> — after two frames, so the first themed paint is underneath
     before the fade starts. SPLASH_MAX_MS is the backstop. */
  private static readonly SPLASH_MAX_MS = 10000;
  private splashTimer: any;
  private splashDone = false;

  private hideSplash() {
    if (this.splashDone) return;
    this.splashDone = true;
    // revealed in the same change detection that mounts the header
    this.booting = false;
    clearTimeout(this.splashTimer);
    const el = document.getElementById('splash-screen');
    if (!el) return;
    this.zone.runOutsideAngular(() => {
      let started = false;
      const fade = () => {
        if (started) return;
        started = true;
        el.classList.add('splash--out');
        // transitionend is skipped under reduced motion; the timeout covers it
        const remove = () => el.parentNode && el.parentNode.removeChild(el);
        el.addEventListener('transitionend', remove, { once: true });
        setTimeout(remove, 400);
      };
      requestAnimationFrame(() => requestAnimationFrame(fade));
      // background tabs never fire animation frames
      setTimeout(fade, 150);
    });
  }

  /* ---- floating rail (WhatsApp + assistant launcher) -------------------
     On phones the two corner buttons sit over content and inputs. They tuck
     away as soon as the page starts scrolling and come back once it has been
     still for FAB_IDLE_MS — the class on <html> is what _ui-tokens.scss
     keys off (phones only). Only page scroll counts (window / <html> /
     <body>, which is the scroller here): swiping an offers strip or a list
     inside a modal leaves them alone. Runs outside Angular so a scroll never
     triggers change detection. */
  private static readonly FAB_IDLE_MS = 1000;
  private fabIdleTimer: any;

  private onPageScroll = (e: Event) => {
    const t = e.target;
    if (t !== document && t !== document.documentElement && t !== document.body) return;

    // keep them put while one of them has keyboard focus
    const active = document.activeElement as HTMLElement | null;
    if (active?.closest('.float-btn, .retail-ai-launcher-wrap')) return;

    const root = document.documentElement;
    if (!root.classList.contains('ui-fab-away')) root.classList.add('ui-fab-away');
    clearTimeout(this.fabIdleTimer);
    this.fabIdleTimer = setTimeout(
      () => root.classList.remove('ui-fab-away'),
      AppComponent.FAB_IDLE_MS
    );
  };

  private watchScrollForFloatingButtons() {
    this.zone.runOutsideAngular(() =>
      // capture: scroll events don't bubble, and <body> is the scroller here
      document.addEventListener('scroll', this.onPageScroll, {
        capture: true,
        passive: true,
      })
    );
  }

  setHeaderVisibility(visible: boolean) {
    this.isHeaderVisible = visible;
  }

  setBottomMenuVisibility(visible: boolean) {
    this.isBottomMenuVisible = visible;
  }

  setFooterVisibility(visible: boolean) {
    this.isFooterVisible = visible;
  }

  setAllergensFooter(visible: boolean) {
    this.isAllergenseFooterVisible = visible;
  }

  setWhatsAppVisibilty(visible: boolean) {
    this.isWhatsAppVisible = visible;
  }

  getwebCustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      // theme is applied by now (ThemeService subscribed first); fade after the next paint
      this.hideSplash();
      this.newDesign = isNewDesign(res);
      // one typeface on the redesign: under this flag _ui-tokens.scss lets
      // <p> and <h1>–<h6> inherit the body's Roboto instead of the legacy
      // style.css Poppins. Legacy-design brands keep Poppins as before.
      if (this.newDesign) document.documentElement.setAttribute('data-ui-design', 'new');
      else document.documentElement.removeAttribute('data-ui-design');
      this.scheduleIdleWork();
      this.bottomMenu = res.TemplateData.BottomMenu?.IsEnabled;
      this.showRetailAIWidget =
        !!res.TemplateData?.RetailAI?.Enabled &&
        !!res.TemplateData?.RetailAI?.Text?.Enabled;
      this.assistantName = res.TemplateData?.RetailAI?.AssistantName;
      this.favIcon.href = res.TemplateData.BusinessInfo.FavIcon;
      this.whatsappno = res.TemplateData.BusinessInfo.WhatsAppNo;
      this.brand_Name = res.BrandData.BrandName;

      //Set Meta Data for SEO
      this.title.setTitle(res.BrandData.BrandName);

      this.meta.updateTag({
        name: 'keywords',
        content: res.TemplateData.HomeTemplate.Keywords,
      });

      this.meta.updateTag({
        name: 'description',
        content: res.TemplateData.HomeTemplate.TagLine,
      });

      // For Favicon Icon in SEO and multiple browser support
      this.meta.updateTag({
        name: 'icon',
        rel: 'icon',
        href: res.TemplateData.BusinessInfo.FavIcon,
        type: 'image/x-icon',
      });

      this.meta.updateTag({
        name: 'shortcut icon',
        rel: 'shortcut icon',
        href: res.TemplateData.BusinessInfo.FavIcon,
        type: 'image/x-icon',
      });
      // For Favicon Icon in SEO and multiple browser support// END

      this._local.set('BrandId', res.BrandData.BrandId);
      this.addFbCode(res);
      this.addGoogleTag(res);
    });
  }

  addGoogleTag(res: WebCustomer) {
    if (
      !res.TemplateData?.GoogleTag?.Source &&
      !res.TemplateData?.GoogleTag?.Config
    )
      return;

    let s = window.document.createElement('script');
    s.id = 'GoogleTagSource';
    s.type = 'text/javascript';
    s.setAttribute('async', 'true');
    s.setAttribute('src', res.TemplateData.GoogleTag.Source);
    window.document.body.appendChild(s);

    let configScript = window.document.createElement('script');
    configScript.id = 'GoogleTagConfig';
    configScript.type = 'text/javascript';
    configScript.setAttribute('async', 'true');
    configScript.innerHTML = res.TemplateData.GoogleTag.Config;
    window.document.body.appendChild(configScript);
  }

  addFbCode(res: WebCustomer) {
    if (!res.TemplateData?.FacebookPixelCode?.script) return;

    this.fbVerification.setAttribute(
      'content',
      res.TemplateData.FacebookPixelCode.fbverification
    );

    let s = window.document.createElement('script');
    s.id = 'fbPixelScript';
    s.type = 'text/javascript';
    s.innerHTML = res.TemplateData.FacebookPixelCode.script;
    s.onload = () => {
      fbq('track', 'PageView');
    };
    window.document.body.appendChild(s);
  }

  handleRecipeOptionModalClose() {
    this.recipeOptionModalState = null;
  }

  onRecipeOptionModalCreated(ref: ComponentRef<RecipeOptionModalComponent>) {
    ref.instance.close.subscribe(() => this.handleRecipeOptionModalClose());
  }

  /* Once the first screen is up and the browser is idle: mount the
     redesigned recommendations popup (it fetches the recommended items,
     which checkout's first open needs) and fetch the chunks of the options
     modal and the header cart, so opening them doesn't wait for the
     network. Only for the new design: the legacy header, popup and
     recommendations are part of main.js and mounted from the start. */
  private scheduleIdleWork() {
    if (this.idleWorkScheduled || !this.newDesign) return;
    this.idleWorkScheduled = true;
    whenIdle(() =>
      this.zone.run(() => {
        if (!this.newRecomendations.mount$.value) {
          this.newRecomendations.mount$.next(true);
        }
        prefetchLazyComponent(loadRecipeOptionModal);
        prefetchLazyComponent(loadNewSideCart);
      })
    );
  }

  openMobileWhatsApp() {
    this.posthog.captureEvent('whatsapp_contact_initiated', {
      platform: 'mobile',
    });
    window.open(
      'https://api.whatsapp.com/send?phone=' + this.whatsappno,
      '_blank'
    );
  }

  openWhatsApp() {
    this.posthog.captureEvent('whatsapp_contact_initiated', {
      platform: 'web',
    });
    window.open(
      'https://web.whatsapp.com/send?phone=' + this.whatsappno,
      '_blank'
    );
  }
}
